import { UserImpersonation } from '@/components/admin/UserImpersonation';

export default function Impersonation() {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">User Impersonation</h1>
      <div className="max-w-2xl">
        <UserImpersonation />
      </div>
    </div>
  );
}
